import { render } from "./LbrxKioskPopup.vue?vue&type=template&id=4b7979d8&scoped=true"
import script from "./LbrxKioskPopup.vue?vue&type=script&lang=js"
export * from "./LbrxKioskPopup.vue?vue&type=script&lang=js"

import "./LbrxKioskPopup.vue?vue&type=style&index=0&id=4b7979d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7979d8"]])

export default __exports__